import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-patient-overview-navigation',
  templateUrl: './patient-overview-navigation.component.html',
  styleUrls: ['./patient-overview-navigation.component.scss'],
  standalone: false,
})
export class PatientOverviewNavigationComponent {
  @Output() backToPatientsList = new EventEmitter<void>();
  @Output() backToPatientOverview = new EventEmitter<void>();
  @Output() backToHome = new EventEmitter<void>();
}
